export default "__VITE_ASSET__DTyqh9mV__"